<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.selectedFields}">
      <ul>
        <li v-for="(field, id) in formattedProfileFields">
          <label>
            <input v-model="selectedProfileFields" :value="id" type="checkbox">
            <span>{{ field }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>
<script type="text/javascript">
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import {capitalize} from "@/EventLogic/util";

  export default {
    filters: {
      capitalize
    },
    extends: BaseComponent,
    props: {
      selectedFields: {
        type: Array,
        default: () => []
      },
      study_id: String,
      id: String,
    },
    data: function () {
      return {
        selectedProfileFields: this.selectedFields,
      }
    },
    computed: {
      formattedProfileFields: function () {
        let typesMap = {};
        this.config.profileFields.map((fieldType) => {
          switch (fieldType) {
            case 'cell_phone':
              typesMap[fieldType] = 'Text Number';
              break;
            case 'home_phone':
              typesMap[fieldType] = 'Voice Number';
              break;
            default:
              // shouldn't end up here but whatever
              typesMap[fieldType] = capitalize(fieldType);
          }
        });
        return typesMap;
      },
    },
    watch: {
      'selectedProfileFields': function() {
        this.$emit('update:selectedFields', this.selectedProfileFields);
      },
      'selectedFields': function(value) {
        this.selectedProfileFields = value;
      }
    },
    created() {
      this.$emit('update:study_id', this.config.study_id);
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.selectedFields || !this.selectedFields.length) {
          this.errors.selectedFields = 'Please select a field.';
        }

        return Object.keys(this.errors).length === 0;
      }
    },
  };
</script>

<style scoped>
  ul {
    column-count: 3;
    column-gap: 2rem;
    list-style: none;
  }
</style>
